import {GlobalVariables} from "../GlobalVariables";
import {ScrollSmoother, ScrollTrigger} from "../LibrariesImport";


export default class SmoothScroll {
	static init() {

		GlobalVariables.smoother = ScrollSmoother.create({
			smooth: 0.8,
		});

		const root = document.documentElement;
		if (ScrollTrigger.isTouch === 1) {
			root.classList.add('touchevents');
		} else {
			root.classList.add('no-touchevents');
		}
	}
}

